var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAIgongchuang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82865 2.41164C6.10778 3.13006 4.0263 5.32492 3.45199 8.08094L3.35701 8.53672C2.881 10.8211 2.881 13.1789 3.35701 15.4633L3.45199 15.9191C4.02632 18.6751 6.1078 20.87 8.82863 21.5884C10.9073 22.1372 13.0927 22.1372 15.1714 21.5884C17.8922 20.8699 19.9737 18.675 20.548 15.9191L20.643 15.4633C21.119 13.179 21.119 10.8211 20.643 8.53671L20.548 8.08089C19.9737 5.32495 17.8922 3.13006 15.1714 2.41164C13.0927 1.86279 10.9073 1.86279 8.82865 2.41164ZM14.6608 4.34537C16.649 4.87035 18.1703 6.47447 18.59 8.48892L18.685 8.94477C19.105 10.96 19.105 13.0401 18.685 15.0553L18.59 15.5111C18.1703 17.5255 16.649 19.1297 14.6608 19.6546C12.9167 20.1152 11.0833 20.1152 9.33923 19.6546C7.35098 19.1297 5.82972 17.5255 5.40993 15.5111L5.31495 15.0553C4.89502 13.0401 4.89502 10.9599 5.31495 8.94472L5.40993 8.48895C5.82971 6.47446 7.35096 4.87035 9.33923 4.34537C10.9587 3.91777 12.6553 3.88723 14.2858 4.25374L14.6608 4.34537ZM12.9933 6.88338C12.9355 6.38604 12.5128 6 12 6C11.4477 6 11 6.44772 11 7V9L11.0067 9.11662C11.0645 9.61396 11.4872 10 12 10C12.5523 10 13 9.55229 13 9V7L12.9933 6.88338Z",
    fill: "#091B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAIgongchuang);
export default __webpack_public_path__ + "static/media/menu_AIgongchuang.a46e9fc8f0cdc9b75e1e7dbad516eeb1.svg";
export { ForwardRef as ReactComponent };